var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.578 40.88l1.15-1.142c.36-.36.557-.838.557-1.35 0-.51-.197-.99-.557-1.349L20.696 24.008 33.743 10.96c.359-.359.557-.838.557-1.348 0-.511-.198-.99-.557-1.35L32.599 7.12a1.91 1.91 0 00-2.697 0l-15.59 15.534c-.359.359-.611.837-.611 1.353v.006c0 .51.253.99.611 1.348l15.547 15.52c.36.359.852.556 1.363.556s.997-.197 1.356-.557z"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
